import React from 'react'

export const PrivacyPolicyComponent = () => {
  return (
    <div className="py-5 py-lg-5 container">
      <div className="col-md-6 offset-md-3">
        <h1>Privacy Policy</h1>
        <p>Last updated: December 26, 2025.</p>
        <p>Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. Please read this policy carefully to understand our views and practices regarding your personal data and how we will treat it.</p>
        <h2>Information We Collect</h2>
        <p>We may collect and process the following data about you:</p>
        <ul>
          <li>Personal identification information (name, email address, phone number, etc.)</li>
        </ul>
        <p>We store only essential data in cookies and similar technologies related to the functional usage of the site.</p>
      </div>
    </div>
  )
}
